import { useAsyncValue, useRouteLoaderData } from "react-router-dom";

import Resolver from "@/components/resolver";

const Renderer = ({ children }) => {
  const account = useAsyncValue();
  if (!account.active) return <span />;
  return <>{children}</>;
};

export default function AuthorizeGate({ children }) {
  const { account } = useRouteLoaderData("root");

  return (
    <Resolver resolve={account}>
      <Renderer>{children}</Renderer>
    </Resolver>
  );
}
